import { render } from "./IdxRelease.vue?vue&type=template&id=e3b0a1ae"
import script from "./IdxRelease.vue?vue&type=script&lang=js"
export * from "./IdxRelease.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__